import { useQuery } from '@tanstack/react-query';
import { Bell } from 'lucide-react';
import { Link } from 'react-router';
import { useApi, useCurrent } from '@/lib/session';

export interface NotificationRow {
  id: string;
  type: string;
  title: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export function NotificationBell() {
  const api = useApi();
  const { can, current } = useCurrent();
  const { data } = useQuery({
    queryKey: ['notifications', 'unread'],
    queryFn: () => api.get<NotificationRow[]>('/v1/core/notifications', { query: { unread: 'true', limit: 50 } }),
    enabled: !!current && can('notifications:read'),
    refetchInterval: 120_000,
  });
  const count = data?.length ?? 0;
  return (
    <Link
      to="/notificacoes"
      aria-label={count ? `Notificações, ${count} não lidas` : 'Notificações'}
      className="relative inline-flex size-9 items-center justify-center rounded-full text-ink transition hover:bg-mist focus-visible:outline-2 focus-visible:outline-violet"
    >
      <Bell className="size-4" aria-hidden />
      {count > 0 && (
        <span className="absolute right-0.5 top-0 min-w-4 rounded-full bg-danger px-1 text-center text-[10px] font-semibold leading-4 text-white">
          {count > 9 ? '9+' : count}
        </span>
      )}
    </Link>
  );
}
